<script>

export default {

    name: 'GeneralEventHandler',

    props: [],

    data() {
        return {
            languageDropdown: null,
            languageDropdownIsOpen: false,
            mobileMenu: null,
            mobileMenuButton: null,
            mobileMenuIsOpen: false,
            headerContent: null,
            headerPlaceholder: null,
            prevScrollY: 0,
            canDock: true,
            canUndock: true,
        }
    },

    created() {

    },

    mounted() {

        this.languageDropdown = document.querySelector('[data-reference="language-dropdown"]');
        this.mobileMenu = document.querySelector('[data-reference="mobile-menu"]');
        this.mobileMenuButton = document.querySelector('[data-reference="mobile-menu-button"]');
        this.headerContent = document.querySelector('.header-content');
        this.headerPlaceholder = document.querySelector('header .placeholder');

        this.Bus.on('toggle-language', () => {
            this.toggleLanguageDropdown();
        });

        this.Bus.on('toggle-mobile-menu', () => {
            this.toggleMobileMenu();
        });

        this.Bus.on('favourite-count-set', (count) => {
            this.setFavouriteCount(count);
        });

        this.Bus.on('open-popup', (reference) => {
            this.undockHeader();
        });

        this.Bus.on('dock-header', (reference) => {
            this.dockHeader();
        });

        this.Bus.on('undock-header', (reference) => {
            this.undockHeader();
        });

        this.Bus.on('navigate-to-url', (data) => {
            if (data.url) {
                if (data.options?.blank) {
                    window.open(data.url, '_blank');
                } else {
                    window.location.href = data.url;
                }
            }
        });

        this.Bus.on('activate-filter', (reference) => {
            this.undockHeader();
        });

        this.Bus.on('handle-search-input', (value) => {
            this.handleSearchInput(value);
        });

        this.Bus.on('close-internal-info-bar', () => {
            this.closeInternalInfoBar();
        });

        window.addEventListener('scroll', this.triggerUpdate, supportsPassive() ? { passive: true } : false);
    },

    methods: {

        triggerUpdate(event) {
            const currentScrollY = window.scrollY;
            let isScrollingUp = currentScrollY < this.prevScrollY;
            this.prevScrollY = currentScrollY;

            if (currentScrollY <= 0) {
                this.resetHeader();
            } else {
                if (isScrollingUp) {
                    if (this.canDock) {
                        this.dockHeader();
                    }
                } else {
                    if (this.canUndock) {
                        this.undockHeader();
                    }
                }
            }
        },

        dockHeader() {
            this.headerContent.classList.add('docked');
            this.headerContent.classList.remove('undocked');

            setTimeout(() => {
                this.canDock = false;
                this.canUndock = true;
            }, 100);

            if (! this.mobileMenuIsOpen) {
                this.headerContent.classList.add('shadow');
            }
        },

        undockHeader() {
            this.headerContent.classList.remove('docked');
            this.headerContent.classList.add('undocked');
            this.headerContent.classList.remove('shadow');

            setTimeout(() => {
                this.canDock = true;
                this.canUndock = false;
            }, 100);
        },

        resetHeader() {
            this.headerContent.classList.remove('docked');
            this.headerContent.classList.remove('undocked');
            this.headerContent.classList.remove('shadow');

            this.canDock = true;
            this.canUndock = true;
        },

        toggleLanguageDropdown() {

            if (this.languageDropdown.classList.contains('overflow-hidden')) {
                // Element is closed, open it
                this.languageDropdown.classList.remove('overflow-hidden', 'h-0', 'max-h-0');
                this.languageDropdown.classList.add('max-h-screen');
            } else {
                // Element is open, close it
                this.languageDropdown.classList.add('overflow-hidden', 'h-0', 'max-h-0');
                this.languageDropdown.classList.remove('max-h-screen');
            }

            this.languageDropdownIsOpen = ! this.languageDropdownIsOpen;
        },

        toggleMobileMenu() {

            if (! this.mobileMenu.classList.contains('active')) {

                this.Bus.emit('set-popup-active-class');

                this.mobileMenu.classList.add('active');
                this.mobileMenuButton.classList.add('active');
                this.headerContent.classList.add('docked');
                this.headerContent.classList.remove('shadow');
                this.headerPlaceholder.classList.add('active');

            } else {

                this.Bus.emit('set-popup-inactive-class');

                this.mobileMenu.classList.remove('active');
                this.mobileMenuButton.classList.remove('active');
                this.headerContent.classList.add('shadow');
                this.headerPlaceholder.classList.remove('active');
            }

            this.mobileMenuIsOpen = ! this.mobileMenuIsOpen;
        },

        setFavouriteCount(count) {
            const target = document.querySelector('.icon-link.favourites');
            target.innerHTML = count;
        },

        handleSearchInput(value) {
            const button = document.querySelector('.button-search');

            if (button) {
                button.classList.remove('active');

                if (value.length > 0) {
                    button.classList.add('active');
                }
            }
        },

        closeInternalInfoBar() {

            document.querySelector('.internal-info-bar').classList.add('hide');

            let expires = "";
            let date = new Date();
            date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();

            document.cookie = "internalInfoBar=0" + expires + "; path=/";
        },

        setCookie(name, value, days) {

        }
    },

    render() {}
}

</script>

